import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import { useEffect } from "react";
// import "react-modern-calendar-datepicker/lib/DatePicker.css";
import "./styles.css";
import { InputLabel } from "@mui/material";
import { ReactComponent as CalenderIcon } from "./icons/calender-icon.svg";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";

export interface DateRangeData {
  from: {
    month: number;
    day: number;
    year: number;
  } | null;
  to: {
    month: number;
    day: number;
    year: number;
  } | null;
}

export interface DateRangePickerPropTypes {
  onChange: (newValue: any) => void;
  dateRange: any;
  setDateRange: Function;
  label?: string;
  required?: string;
  placeholder?: string;
  maximumDate?: any;
  setFilterData: Function;
  inputClassName?: string;
  isBooking?: boolean;
}

const DateRangePicker: React.FC<DateRangePickerPropTypes> = ({
  dateRange,
  onChange,
  label,
  required,
  placeholder,
  maximumDate,
  setDateRange,
  setFilterData,
  inputClassName = "",
  isBooking = false,
}) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const formatDate = (
    date: { month: number; day: number; year: number } | null
  ) => {
    if (!date) return "";
    return `${date.day} ${monthNames[date.month - 1]} ${date.year}`;
  };

  const renderCustomInput = ({ ref }: any) => (
    <div>
      {label && (
        <InputLabel className="dateRangeInput">
          {label}
          {required ? " * " : ""}
        </InputLabel>
      )}
      <div
        style={{ display: "flex", alignItems: "center", position: "relative" }}
      >
        {inputClassName && (
          <>
            {isBooking ? (
              <CalendarMonthOutlinedIcon
                style={{
                  position: "absolute",
                  left: "19px",
                  top: "12px",
                  cursor: "pointer",
                }}
              />
            ) : (
              <CalenderIcon
                style={{
                  position: "absolute",
                  left: "19px",
                  top: "25px",
                  cursor: "pointer",
                }}
              />
            )}
          </>
        )}
        <input
          className={inputClassName}
          readOnly
          ref={ref}
          placeholder={placeholder}
          value={
            dateRange.from && dateRange.to
              ? `${formatDate(dateRange.from)} - ${formatDate(dateRange.to)}`
              : ""
          }
          style={{
            width: `${isBooking ? "17vw" : "22vw"}`,
            height: "47px",
            marginTop: "10px",
            color: "#43463b",
            outline: "none",
            marginLeft: "10px",
            paddingLeft: `${inputClassName ? "35px" : "0px"} `,
          }}
        />
      </div>
    </div>
  );
  const renderFooter = () => (
    <div
      style={{
        justifyContent: "center",
        marginLeft: "140px",
        paddingBottom: "20px",
      }}
    >
      <button
        type="button"
        className="resetButton"
        onClick={() => {
          setDateRange({
            from: null,
            to: null,
          });
          setFilterData({ startDate: null, endDate: null });
        }}
        style={{
          border: "#43463b",
          color: "#43463b",
          borderRadius: "0.5rem",
          cursor: "pointer",
        }}
      >
        Reset Value!
      </button>
    </div>
  );
  return (
    <div className="datepicker-container">
      <DatePicker
        value={dateRange}
        inputPlaceholder={placeholder}
        renderInput={renderCustomInput}
        shouldHighlightWeekends
        onChange={onChange}
        maximumDate={maximumDate}
        renderFooter={renderFooter}
      />
    </div>
  );
};

export default DateRangePicker;
